// import AppStore from '@component/AppStore'
// import Google from '@component/icons/Google'
// import Instagram from '@component/icons/Instagram'
// import Twitter from '@component/icons/Twitter'
// import Youtube from '@component/icons/Youtube'
// import { Paragraph } from '@component/Typography';
import { Link, Box, Container, Grid, styled, Typography } from '@material-ui/core';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { FC } from 'react';
import Image from '../components/DirectImage';

// styled component
const StyledLink = styled('a')(({ theme }) => ({
  position: 'relative',
  display: 'block',
  padding: '0.3rem 0rem',
  color: theme.palette.grey[500],
  cursor: 'pointer',
  borderRadius: 4,

  '&:hover': {
    color: theme.palette.grey[100]
  }
}));

export default function Footer() {
  return (
    <footer>
      <Box bgcolor="#0c0e30">
        <Container sx={{ p: '1rem', color: 'white' }}>
          <Box py={10} overflow="hidden">
            <Grid container spacing={3}>
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Link href="/">
                  <a>
                    <Image width="100px" height="70px" src="/assets/images/logo.svg" alt="logo" />
                  </a>
                </Link>

                <Typography variant="body1" mb={2.5} color="grey.500">
                  Our Vision: First choice professional association for Teachers in Zimbabwe.
                </Typography>

                {/* <AppStore /> */}
              </Grid>

              <Grid item lg={2} md={6} sm={6} xs={12}>
                <Box fontSize="25px" fontWeight="600" mb={2.5} lineHeight="1" color="white">
                  About Us
                </Box>

                <div>
                  {aboutLinks.map((item, ind) => (
                    <Link href={item.url} key={ind}>
                      <StyledLink>{item.title}</StyledLink>
                    </Link>
                  ))}
                </div>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <Box fontSize="25px" fontWeight="600" mb={2.5} lineHeight="1" color="white">
                  Customer Care
                </Box>

                <div>
                  {customerCareLinks.map((item, ind) => (
                    <Link href={item.url} key={ind}>
                      <StyledLink>{item.title}</StyledLink>
                    </Link>
                  ))}
                </div>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <Box fontSize="25px" fontWeight="600" mb={2.5} lineHeight="1" color="white">
                  Contact Us
                </Box>
                <Box py={0.6} color="grey.500">
                  <strong>Harare:</strong> 190 Herbert Chitepo Ave
                </Box>
                <Box py={0.6} color="grey.500">
                  <strong>Harare:</strong> P O Box 1440 Harare
                </Box>
                <Box py={0.6} color="grey.500">
                  Email: info@zimta.co.zw
                </Box>
                <Box py={0.6} mb={2} color="grey.500">
                  Phone: (+263) 242 2706441
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </footer>
  );
}

const aboutLinks = [
  // 'Careers',
  // 'Our Stores',
  // 'Our Cares',
  { title: 'Terms & Conditions', url: '/underdev' },
  // { title: 'Privacy Policy', url: '/static/privacy' },
  { title: 'Privacy Policy', url: '/underdev' }
];

const customerCareLinks = [
  { title: 'Help Center', url: '/underdev' },
  { title: 'How to Apply for Refund', url: '/underdev' }

  // 'Track Your Order',
  // 'Corporate & Bulk Purchasing',
  // 'Returns & Refunds',
];

// const iconList = [
//   { icon: Facebook, url: 'https://www.facebook.com/UILibOfficial' },
//   // { icon: Twitter, url: 'https://twitter.com/uilibofficial' },
//   // {
//   //   icon: Youtube,
//   //   url: 'https://www.youtube.com/channel/UCsIyD-TSO1wQFz-n2Y4i3Rg',
//   // },
//   // { icon: Google, url: '/' },
//   // { icon: Instagram, url: 'https://www.instagram.com/uilibofficial/' },
// ]
